import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent, CampaignMessage, MessageInfo, MessagesService } from 'lib-trend-core';

@Component({
    selector: 'campaign-message-payload-edit',
    templateUrl: './campaign-message-payload.v2.component.html',
    // templateUrl: './campaign-message-payload.component.html',
    styleUrls: ['./campaign-message-payload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CampaignMessagePayloadComponent extends AbstractComponent {

  copied = false;

  errorMessage: string;
  failedMessage: string;

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) public campaignMessage: CampaignMessage,
    private dialogRef: MatDialogRef<CampaignMessagePayloadComponent>,
    private messagesService: MessagesService,
  ) {
    super(injector)
  }

  onClose(): void {
    this.dialogRef.close()
  }

  get messageId(): string {
    return this.campaignMessage?.messageId
      || (this.campaignMessage?.payload as any)?.result?.messages?.[0]?.id
      || '';
  }

  copyMessageId(): void {
    navigator.clipboard.writeText(this.messageId);
    this.alertService.success(this.t('campaign.messagePayload.messageIdCopied'));
  }

  ngOnInit(): void {
    this.campaignMessage.payload = this.campaignMessage.payload ?? {}
  }

  copyPayload(): void {
    const json = JSON.stringify(this.campaignMessage.payload, null, 2);
    navigator.clipboard.writeText(json).then(() => {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    });
  }

  getMessageErrorReason() {
    this.errorMessage = String(JSON.stringify(this.campaignMessage.payload, null, 2))
      .replace(/["{}\[\],]/g, '') // remove aspas e símbolos
      .replace(/:\s*/g, ': ')     // ajusta espaços após :
      .replace(/\n\s+/g, '\n')    // remove indentação
      .trim();
  }

  getMessageFailedReason() {
    this.messagesService.getMessageInfoByMessageId(this.messageId).subscribe({
      next: (messageInfo: MessageInfo) => {
        if (!messageInfo?.statuses?.length) {
          this.alertService.info(this.t('campaign.messagePayload.noProviderHistory'));
          return;
        }
        this.failedMessage = String(JSON.stringify(messageInfo.statuses, null, 2))
          .replace(/["{}\[\],]/g, '') // remove aspas e símbolos
          .replace(/:\s*/g, ': ')     // ajusta espaços após :
          .replace(/\n\s+/g, '\n')    // remove indentação
          .trim();
      }
    });
  }

  goToGoogleTranslate(message: string) {
    const urlGoogleTranslate = `https://translate.google.com/?sl=auto&tl=pt&text=${encodeURIComponent(message)}&op=translate`;
    window.open(urlGoogleTranslate, '_blank');
  }

}
